
import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
/**
 *
 */
EDC.Games.WelcomeBackPage.Scenes.Main = function () {};

const welcomeBackPage = EDC.Games.WelcomeBackPage.Scenes.Main.prototype;

welcomeBackPage.init = function () {
  this.bg = null;
  this.content = null;
  this.cursorManager = null;
  this.logo = null;
  this.scale.off('resize', this.resize, this);
};

welcomeBackPage.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);

  this.bg = this.add.image(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  const titleFrame = this.add.image(0, 200, 'title-frame').setOrigin(0);
  this.logo = this.add.image(0, 0, 'logo');
  this.logo.init_scale = 1;
  const titleText = this.add.image(
    titleFrame.displayWidth / 2,
    titleFrame.y + titleFrame.displayHeight / 2,
    'title-text',
  );
  const messageFrame = this.add.image(580, 670, 'message-frame');
  const message = this.add.image(messageFrame.x, messageFrame.y, 'message');

  const continueBtnFrame = this.add.image(0, 0, 'continue-btn-frame');
  const continueBtnFrameHover = this.add.image(0, 0, 'continue-btn-frame-hover').setVisible(false);
  const continueBtnText = this.add.image(-75, 0, 'continue-btn-text');
  const continueBtnIcon = this.add.image(190, 0, 'continue-btn-icon');
  const continueBtn = this.add.container(message.x - 10, 970, [
    continueBtnFrame,
    continueBtnFrameHover,
    continueBtnText,
    continueBtnIcon,
  ]);
  continueBtn.setSize(continueBtnFrame.displayWidth, continueBtnFrame.displayHeight);
  continueBtn.setInteractive();

  continueBtn.on('pointerdown', () => {
    router.push({ name: 'game-type-picker' });
    this.game.destroy(true);
  });
  continueBtn.on('pointerover', () => {
    continueBtn.getAt(1).setVisible(true);
  });
  continueBtn.on('pointerout', () => {
    continueBtn.getAt(1).setVisible(false);
  });

  this.cursorManager.setDefaultDraggableEvents(continueBtn);

  this.content.add([titleFrame, titleText, messageFrame, message, continueBtn]);

  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });

  this.tweens.add({
    targets: continueBtnIcon,
    ease: 'Sine.easeInOut',
    duration: 1000,
    x: 210,
    loop: -1,
    yoyo: true,
  });
  
  // Bounce title
  this.tweens.add({
    targets: titleText,
    ease: "Bounce.easeOut",
    duration: 1000,
    y: 300,
    loop: - 1,
    yoyo: true
  });

  const targets = [titleFrame, titleText, this.logo];
  targets.map((target) => {
    target.y -= 200;
    return target.y;
  });
  this.tweens.add({
    targets,
    duration: 1000,
    y(target) {
      return target.y + 200;
    },
    ease: 'Bounce.easeOut',
  });
};

welcomeBackPage.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;
  this.cameras.resize(width, height);
  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);
  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.8) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition(
    (width - bounds.width) / 2 + 120 * neededScale,
    height / 2 - bounds.height + 170 * neededScale,
  );

  this.logo.setScale(this.logo.init_scale * neededScale);
  this.logo.setPosition(this.content.x + bounds.width / 2 - 760 * neededScale,
    this.content.y + 320 * neededScale);
};

export default EDC.Games.WelcomeBackPage.Scenes.Main;
